(function ($, Drupal) {
  Drupal.behaviors.backLink = {
    attach: function attach(context) {
      $('.js-back', context).on('click', (e) => {
        e.preventDefault();
        window.history.back();
      });
    },
  };

  Drupal.behaviors.backLinkTwo = {
    attach: function attach(context) {
      $('.js-back-two', context).on('click', (e) => {
        e.preventDefault();
        window.history.back(-2);
      });
    },
  };
}(jQuery, Drupal));
